import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { userInitials } from 'utils';

export default (healthcareServiceId) => {
  const { t, i18n } = useTranslation('genders');

  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/patient/bookings/healthcare_service_providers`, { healthcareServiceId, followUp: true }], {
    enabled: !!healthcareServiceId,
  });

  const options = useMemo(
    () =>
      data?.data.map((x) => ({
        id: x.id,
        providerName: x.attributes.fullName,
        showCalendarAvailability: x.attributes.showCalendarAvailability,
        providerInitials: userInitials.getUserInitials(x.attributes.firstName, x.attributes.lastName),
        tags: [t(x.attributes.gender)], // x.attributes.degreeDesignation, // temporary commented
        degrees: x.attributes.degreeDesignations.filter((d) => d.degreeType === 'degree'),
        designations: x.attributes.degreeDesignations.filter((d) => d.degreeType === 'designation'),
      })),
    [data, i18n.language],
  );

  return { data: options || [], isLoading, isSuccess };
};
